import { createFileRoute } from "@tanstack/react-router";
import Landing from "../rh/landing";

export const Route = createFileRoute("/")({ component: Landing });
